import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Button, Stack, TextField } from "@mui/material";
import { Box, TextareaAutosize } from "@mui/material";
import HighLightedCard from "../Cards/HighLightedCard";
import CustomCalendar from "../Calendar/Calendar";
import DateRange from "../Calendar/DateRange";
import { useState } from "react";
import Calendar from "react-calendar";
import { useGetSubscriptionCancelMutation, useGetSubscriptionpauseMutation, useSubscriptionUpdateMutation } from "../../../api/subscription";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { jsPDF } from "jspdf";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CustomTextArea = styled(TextareaAutosize)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "15px",
  gap: "10px",
  width: "501px",
  height: "137px !important",
  background: " #FFFFFF",
  border: "1px solid #E1E1E6",
  borderRadius: "4px",
});

const CustomButton = styled("a")({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "150%",
  letterSpacing: "0.015em",
  textDecorationLine: "underline",
  color: " #2B817B",
});

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const TopBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 10,
});

const ButtonBox = styled(Box)({
  cursor: "pointer",
  padding: 2,
});

const TopHeading = styled(Typography)({
  width: "100%",
  textAlign: "center",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
});

const CustomDateTypo = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "180%",
  letterSpacing: "0.01em",
  color: "#1A1824",
});

const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "16px",
  width: "244px",
  height: "76px",
  border: "1px solid #E1E1E6",
  borderRadius: "6px",
  justifyContent: "center",
});

const SubHeadings = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "140%",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  letterSpacing: "0.015em",
  color: "#1A1824",
});

const SubTitle = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  marginTop: 10,
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "140%",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  letterSpacing: "0.015em",
  color: "#1A1824",
});

const FlexBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

const CustomStack = styled(Box)({
  display: "flex",
  alignItems: "center",
  //maxWidth: "531px",
  justifyContent: "space-between",
  margin: "30px auto"
});

const LightTitle = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
});

const CustomPlaceHolder = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "145%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
});

const StartDate = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "15px",
  gap: "10px",
  width: "222px",
  height: "9px",
  background: "#F6F6F6",
  border: "1px solid #E1E1E6",
  borderRadius: "4px",
});

export default function CustomizedDialogs({
  isOpen,
  stateFunc,
  type,
  typeFunc,
  dateOpenFunc,
  dateOpen,
  hasTopInput,
  data
}) {

  const [open, setOpen] = React.useState(isOpen);
  // const { getSubscriptionCancel, isLoading: data } = useGetSubscriptionCancelQuery();
  // const { getSubscriptionCancel, isLoading: data } = useGetSubscriptionCancelQuery();
  console.log("data", data)


  const handleClose = () => {
    stateFunc(false);
    dateOpenFunc('');
    typeFunc('');
  };

  const [previosDate, setpreviosDate] = useState(new Date())
  const [nextDate, setnextDate] = useState(new Date())

  const prevDate = (e) => {
    // console.log(e)
    setpreviosDate(e)
  }

  const nxtDate = (e) => {


    const differenceInDays = Math.round((new Date(e) - new Date(previosDate)) / (24 * 60 * 60 * 1000));

    console.log("differenceInDays", differenceInDays)
    if (differenceInDays <= 14) {
      setnextDate(e);
    } else {
      setnextDate(null);
    }
  }
  const [reason, setReason] = useState("")
  const [OtherReason, setOtherReason] = useState("")


  // getSubscriptionCancel()
  const [getSubscriptionCancel] = useGetSubscriptionCancelMutation()
  const cancelSub = () => {
    console.log(reason)
    // getSubscriptionCancel()

    getSubscriptionCancel({ reason: reason, id: data?._id }).then((res) => {
      console.log("res", res)
      if (res.data) {
        console.log("res", res)
        handleClose()
        Swal.fire("Success", res.message, "success")
      } else {
        handleClose()
        Swal.fire("Error", res.error.data, "error")
      }
    })
  }

  const [getSubscriptionPause] = useGetSubscriptionpauseMutation()
  const pauseSub = () => {
    console.log("previosDate", previosDate)
    console.log("nextDate", nextDate)
    // getSubscriptionCancel()

    getSubscriptionPause({ id: data?._id, to: nextDate, from: previosDate }).then((res) => {
      if (res.data) {
        console.log("res", res)
        handleClose()
        Swal.fire("Success", res.message, "success")
      } else {
        handleClose()
        Swal.fire("Error", res.error.data, "error")
      }
    })
  }

  const [subscriptionUpdate] = useSubscriptionUpdateMutation()
  const chngeAddress = () => {
    // alert(OtherReason)
    subscriptionUpdate({ id: data?._id, deliveryAddress: OtherReason }).then((res) => {
      console.log("res", res)
      if (res.data) {
        console.log("res", res)
        handleClose()
        Swal.fire("Success", res.message, "success")
      } else {
        handleClose()
        Swal.fire("Error", res.error.data, "error")
      }
    })

  }

  const downloadReceipt = () => {
    handleClose()
    const doc = new jsPDF();
    // Convert numerical data to strings before adding to the PDF
    const startDateString = data?.startDate?.slice(0, 10);
    const subIdString = data?.subId;
    const quantityString = data?.quantity.toString(); // Convert quantity to string
    const totalPriceString = data?.totalPrice.toString(); // Convert total price to string
    const totalPaymentString = data?.totalPayment.toString(); // Convert total payment to string

    doc.text("Date: ", 10, 10);
    doc.text(startDateString, 50, 10);
    doc.text("Receipt Number: ", 10, 20);
    doc.text(subIdString, 50, 20);
    doc.text("Quantity: ", 10, 30);
    doc.text(quantityString, 50, 30);
    doc.text("Price: ", 10, 40);
    doc.text(totalPriceString, 50, 40);
    doc.text("Payment: ", 10, 50);
    doc.text(totalPaymentString, 50, 50);


    doc.save(`${data?.subId} receipt.pdf`);
  }

  return (
    <>
      {type === "pause-subscription" && (
        <>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            style={{ minWidth: "636px" }}
          >
            <TopBox>
              <ButtonBox style={{ color: "red" }} onClick={() => { handleClose() }}>
                <i className="fa fa-times"></i>
              </ButtonBox>
              <TopHeading>
                Pause Subscription
              </TopHeading>
            </TopBox>
            <Box style={{ padding: 20 }}>
              <LightTitle>
                You can pause maximum is <strong style={{ color: "black", marginRight: "5px" }}>
                  2 weeks
                </strong>
                for free after the two week pause,
                <strong style={{ color: "black", marginRight: "5px" }}>
                  $10
                </strong>
                per week will be charged
              </LightTitle>
              <FlexBox>
                <FlexBox
                  flexDirection={"column"}
                  alignItems={"flex-start !important"}
                >
                  <FlexBox width={"100%"}>
                    <SubHeadings>
                      Pause Period
                    </SubHeadings>

                  </FlexBox>
                  <Stack
                    spacing={6}
                    mt={2}
                    direction={"row"}
                    justifyContent={"space-between"}
                  >
                    <Box sx={{ display: "flex", flexDirection: "column" }} >
                      <StartDate mb={2}>
                        <CustomPlaceHolder>Start Date</CustomPlaceHolder>
                        <i className="fa fa-calendar" style={{ color: "#9EA3AE" }}></i>
                      </StartDate>
                      <Calendar
                        onChange={prevDate}
                        nextLabel={
                          <i class="fa fa-chevron-right" style={{ color: "#2B817B" }}></i>
                        }
                        prevLabel={
                          <i class="fa fa-chevron-left" style={{ color: "#2B817B" }}></i>
                        }
                        value={previosDate}
                      />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }} >
                      <StartDate mb={2}>
                        <CustomPlaceHolder>End Date</CustomPlaceHolder>
                        <i className="fa fa-calendar" style={{ color: "#9EA3AE" }}></i>
                      </StartDate>
                      <Calendar
                        onChange={nxtDate}
                        nextLabel={
                          <i class="fa fa-chevron-right" style={{ color: "#2B817B" }}></i>
                        }
                        prevLabel={
                          <i class="fa fa-chevron-left" style={{ color: "#2B817B" }}></i>
                        }
                        value={nextDate}
                      />
                    </Box>
                  </Stack>
                  {/* {dateOpen === "selectDate"?<DateRange hasTopInput={type === "pause-subscription"}/>:''} */}
                </FlexBox>
              </FlexBox>
              <Box mt={2}>
                <Stack spacing={2}>
                  <CustomStack>
                   <Button variant="outlined" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, mr: 1, }} onClick={() => handleClose()}>
                    I’m not sure
                  </Button>
                    <Button variant="contained" style={{ width: "258px" }} onClick={pauseSub} disabled={nextDate !== null ? false : true} >
                      Pause subscription
                      {/* Cancel subscription */}
                    </Button>
                  </CustomStack>
                </Stack>
              </Box>
            </Box>
          </BootstrapDialog>
        </>
      )}
      {type === "cancel-subscription" && (
        <>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            style={{ minWidth: "636px" }}
          >
            <TopBox>
              <ButtonBox style={{ color: "red" }} onClick={() => { handleClose() }}>
                <i className="fa fa-times"></i>
              </ButtonBox>
              <TopHeading>
                Cancel Subscription
              </TopHeading>
            </TopBox>
            <Box
              style={{
                width: "100%",
                alignItem: "center",
                justifyContent: "center",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <TopContainer>
                <CustomDateTypo>
                  <i className="fas fa-calendar" style={{ marginRight: "10px" }}></i> {Math.round((new Date(data.endDate) - new Date()) / (24 * 60 * 60 * 1000))} Days Remaining
                </CustomDateTypo>
              </TopContainer>
            </Box>
            <Box style={{ padding: 20, }}>
              <FlexBox sx={{
                alignItems: "flex-start", justifyContent: "space-between",
                // border: "1px solid red"
              }}>
                <SubHeadings>
                  Pause Period
                </SubHeadings>
                <CustomButton sx={{ cursor: "pointer" }} onClick={() => dateOpenFunc('selectDate')}>Select</CustomButton>
              </FlexBox>
              {dateOpen === "selectDate" ? <DateRange hasTopInput={type === "pause-subscription"} /> : ''}
              <FlexBox mt={2}>
                <SubHeadings>Cancelation Reason</SubHeadings>
              </FlexBox>
              <Box mt={2}>
                <FormControl style={{ width: "100%" }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {[
                      "I have some problem",
                      "Caterer not have good service",
                      "Delivery time is often late",
                      "Other",
                    ].map((text) => (
                      <FormControlLabel value={text.split(" ").join("-")} control={<Radio />} label={text.split(" ").join("-")} onChange={(e) => setReason(e.target.value)} />
                    ))}

                  </RadioGroup>
                </FormControl>
                <Stack spacing={2}>
                  <CustomTextArea
                    aria-label="empty textarea"
                    placeholder="Add Some"
                    onChange={(e) => setOtherReason(e.target.value)}
                  />

                  <HighLightedCard price={data.totalPrice} />

                  <CustomStack>
                    <Button variant="outlined" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, mr: 1, }} onClick={() => handleClose()}>
                      I’m not sure
                    </Button>
                    <Button variant="contained" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, }} onClick={cancelSub}>
                      Cancel subscription
                    </Button>
                  </CustomStack>
                </Stack>
              </Box>
            </Box>
          </BootstrapDialog>
        </>
      )}
      {type === "change-address" && (
        <>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            maxWidth="sm" // Set the maxWidth property to control the width of the modal
            fullWidth // Set fullWidth to true to allow the dialog to occupy the full width of its container
          // style={{ border: "1px solid red" }} // Additional styling if needed
          >
            <Box sx={{ width: "100%", }}>

              <TopBox>
                <ButtonBox style={{ color: "red" }} onClick={() => { handleClose() }}>
                  <i className="fa fa-times"></i>
                </ButtonBox>
                <TopHeading>
                  Change Address
                </TopHeading>
              </TopBox>
              <Box
                style={{
                  width: "100%",
                  alignItem: "center",
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "20px",
                }}
              >
                <TopContainer>
                  <CustomDateTypo>
                    <i className="fas fa-calendar" style={{ marginRight: "10px" }}></i> {Math.round((new Date(data.endDate) - new Date()) / (24 * 60 * 60 * 1000))} Days Remaining
                  </CustomDateTypo>
                </TopContainer>
              </Box>
              <Box style={{ padding: 20, }}>
                {/* <CustomTextArea
                aria-label="empty textarea"
                placeholder="Add Some"
                onChange={(e) => setOtherReason(e.target.value)}
              /> */}
                <TextField
                  placeholder="Change address"
                  value={OtherReason}
                  onChange={(e) => setOtherReason(e.target.value)}
                  sx={{ width: "100%" }}
                />
                <CustomStack>
                  <Button variant="outlined" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, mr: 1, }} onClick={() => handleClose()}>
                    I’m not sure
                  </Button>
                  <Button variant="contained" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, textTransform: "capitalize" }} onClick={chngeAddress}>
                    change address
                  </Button>
                </CustomStack>
              </Box>
            </Box>
          </BootstrapDialog>
        </>
      )}
      {type === "view-receipt" && (
        <>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            maxWidth="sm" // Set the maxWidth property to control the width of the modal
            fullWidth // Set fullWidth to true to allow the dialog to occupy the full width of its container
          // style={{ border: "1px solid red" }} // Additional styling if needed
          >
            <Box sx={{ width: "100%", }}>

              <TopBox>
                <ButtonBox style={{ color: "red" }} onClick={() => { handleClose() }}>
                  <i className="fa fa-times"></i>
                </ButtonBox>
                <TopHeading>
                  View Receipt
                </TopHeading>
              </TopBox>
              <Box
                style={{
                  width: "100%",
                  alignItem: "center",
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "20px",
                }}
              >
                <TopContainer>
                  <CustomDateTypo>
                    <i className="fas fa-calendar" style={{ marginRight: "10px" }}></i> {Math.round((new Date(data.endDate) - new Date()) / (24 * 60 * 60 * 1000))} Days Remaining
                  </CustomDateTypo>
                </TopContainer>
              </Box>
              <Box style={{ padding: 20, }}>

                <Box sx={{
                  border: "1px solid #E1E1E6",
                  borderRadius: "5px",
                  textAlign: "center",
                  p: 2,
                }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography>Date:</Typography>
                    <Typography>{data?.startDate?.slice(0, 10)}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography>Receipt Number:</Typography>
                    <Typography>{data?.subId}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography>Quantity:</Typography>
                    <Typography>{data?.quantity}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography>Price:</Typography>
                    <Typography>{data?.totalPrice}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", my: 2 }}>
                    <Typography sx={{ fontWeight: "bold" }}>Payment</Typography>
                    <Typography sx={{ ml: 2, fontWeight: "bold" }}>{data?.totalPayment}rs</Typography>
                  </Box>
                </Box>

                <CustomStack>
                  <Button variant="outlined" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, mr: 1, }} onClick={() => handleClose()}>
                    I’m not sure
                  </Button>
                  <Button variant="contained" sx={{ width: { lg: "45%", md: "50%", sm: "40%", xs: "40%" }, textTransform: "capitalize" }} onClick={downloadReceipt}>
                    Download Receipt
                  </Button>
                </CustomStack>
              </Box>
            </Box>
          </BootstrapDialog>
        </>
      )}
    </>


  );
}
